import { api } from '@/constants'
import { getAuthHeader, getAuthAndMultipartHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const common = {
  uploadImage: payloads => {
    const url = api.image.upload
    return baseURL.post(url, payloads, { headers: getAuthAndMultipartHeader() })
  },
  checkAwb: awbNumber => {
    const url = api.awb(awbNumber)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  ongkir: params => {
    const url = api.ongkir + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  logisticProvider: params => {
    const url = api.logisticProvider + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}
export default common
